import React from 'react';
import { Link } from 'react-router-dom';

export default () => (
  <footer className="footer">
    <section>
      <span className="normal-text hover under" id="estrutura">
        <Link to="/estrutura-do-curso">Estrutura do Curso</Link>
      </span>
      <span className="normal-text hover under" id="selecao">
        <Link to="/selecao-de-formandos">Seleção de Formandos</Link>
      </span>
      <span className="normal-text hover under" id="empresas">
        <Link to="/empresas-aderentes">Empresas Aderentes</Link>
      </span>
    </section>

    <section>
      <span className="normal-text hover under" id="lideres">
        <Link to="/testemunhos">Testemunhos</Link>
      </span>
      <span className="normal-text hover under ">
        <Link to="/noticias">Notícias</Link>
      </span>
      <span className="normal-text hover under ">
        <Link to="/videos">Vídeos</Link>
      </span>
    </section>
    <section>
      <span className="normal-text hover under ">
        <Link to="/faqs">FAQs</Link>
      </span>
      <span className="normal-text hover under ">
        <a href="mailto:coord-aor@dei.uc.pt" target="_blank" rel="noopener noreferrer">
          coord-aor@dei.uc.pt
        </a>
      </span>
      <span className="normal-text hover under ">
        <a href="mailto:info@acertarorumo.pt" target="_blank" rel="noopener noreferrer">
          info@acertarorumo.pt
        </a>
      </span>
    </section>
  </footer>
);
